import { render, staticRenderFns } from "./account-simple.vue?vue&type=template&id=0988ba5c&scoped=true&"
import script from "./account-simple.vue?vue&type=script&lang=js&"
export * from "./account-simple.vue?vue&type=script&lang=js&"
import style0 from "./account-simple.vue?vue&type=style&index=0&id=0988ba5c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988ba5c",
  null
  
)

export default component.exports